<template>
  <div class="page-content">
		<el-title :index="index + 2" :parent_data="active_study.etudeData.gie.sectionSynthesePreconisations"
					property="titre"
					:editable="true" style="margin-bottom: 5px">
			Synthèse et préconisations&nbsp;:
		</el-title>


		<section-synthese-preconisation />

		<div class="q-mt-lg q-mb-md">
		<p class="label main_color_text">
			Positionnement de l’offre par rapport aux capacités budgétaires des
			ménages locaux
		</p>
		</div>
		<section-positionnement-offre />
		<div class="q-mt-lg q-mb-md">
		<p class="label main_color_text">
			Corrélation entre le prix de vente moyen de la résidence et les rythmes
			de vente envisageables
		</p>
		</div>

		<el-table :table="correlation_prix_rythme_table" variant="bordered" />

		<div class="q-mt-lg">
		<div class="comment">
			<el-textarea
			:parent_data="
				active_study.etudeData.gie.sectionSynthesePreconisations
			"
			property="commentaire"
			:editable="true"
			height="190px"
			overflow_edit="hidden scroll"
			placeholder="Préciser"
			/>
		</div>
	</div>
	
  </div>
</template>

<script>
import { mapGetters } from "vuex";


import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import sectionPositionnementOffre from "@/components/study/editor/pages/sections/section-positionnement-offre";
import sectionSynthesePreconisation from "@/components/study/editor/pages/sections/section-synthese-preconisation";
export default {
	name: "page-gie-4",
	mixins: [PageMixin],
	data: function () {
		return {
			form: {},
		};
	},
	props: ["index"],
	components: {
		sectionPositionnementOffre,
		sectionSynthesePreconisation
	},
	computed: {
		...mapGetters([
			"active_study",
			"app_parameters",
			"editor",
		]),
		logement_proximite_table_lines () {
			return parseInt(
				this.active_study.etudeData.gie.sectionSynthesePreconisations
					.logement_proximite_table_lines
			);
		},
		correlation_prix_rythme_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [10, 10, 19, 19, 10, 10, 10, 12],
				},
			};

			table.head.push([
				"",
				"",
				"",
				"",
				{
					value: "Rythme de vente mensuel*",
					colspan: 3,
					bg_color: "header",
					text_color: "white",
					text_align: "center",
				},
				{
					value: "Estimation durée moyenne de comm.",
					rowspan: 2,
					bg_color: "header",
					text_color: "white",
				},
			]);

			table.head.push([
				{
					value: "Gamme prix/m²",
					colspan: 2,
					bg_color: "header",
					text_color: "white",
				},
				{
					value: "Cibles",
					bg_color: "header",
					text_color: "white",
				},
				{
					value: "Concurrence",
					bg_color: "header",
					text_color: "white",
				},
				{
					value: "Rapide",
					bg_color: "header",
					text_color: "white",
					text_align: "center",
				},
				{
					value: "Normal",
					bg_color: "header",
					text_color: "white",
					text_align: "center",
				},
				{
					value: "Lent",
					bg_color: "header",
					text_color: "white",
					text_align: "center",
				},
			]);

			const loc =
			this.active_study.etudeData.gie.sectionSynthesePreconisations
				.correlation_prix_rythme_table;
			
			loc.forEach((row) => {
				table.body.push([
					{
						parent_data: row,
						property: "gamme_prix_bas",
						editable: true,
						bg_color: "gray",
						suffix: " €",
					},
					{
						parent_data: row,
						property: "gamme_prix_haut",
						editable: true,
						bg_color: "gray",
						suffix: " €",
					},
					{
						parent_data: row,
						property: "cibles",
						editable: true,
					},
					{
						parent_data: row,
						property: "concurrence",
						editable: true,
					},
					{
						parent_data: row,
						property: "rythme_rapide",
						editable: true,
						bg_color: "green",
						text_align: "center",
					},
					{
						parent_data: row,
						property: "rythme_normal",
						editable: true,
						bg_color: "yellow",
						text_align: "center",
					},
					{
						parent_data: row,
						property: "rythme_lent",
						editable: true,
						bg_color: "orange",
						text_align: "center",
					},
					{
						parent_data: row,
						property: "estimation_duree_comm",
						editable: true,
					},
				]);
			});

			return table;
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';
</style>
